import { Pipe, PipeTransform } from '@angular/core';
import { ProductName } from '../../graphql-client/graphql';

@Pipe({
  name: 'format'
})
export class FormatPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return value === ProductName.Evenity ? 'EVENITY' : 'Prolia';
  }
}
